const ProductInfo = {
  'pages_product_ProductInfo.1': '상품 정보 관리',
  'pages_product_ProductInfo.2': '상품 정보',
  'pages_product_ProductInfo.title.1' :'상품 레벨 1',
  'pages_product_ProductInfo.title.2' :'상품 레벨 2',
  'pages_product_ProductInfo.title.3' :'상품 카테고리',
  'pages_product_ProductInfo.title.4' :'상품명',
  'pages_product_ProductInfo.title.5' :'상품 설명',
  'pages_product_ProductInfo.title.6' :'신규 여부',
  'pages_product_ProductInfo.title.7' :'활성화 상태',
  'pages_product_ProductInfo.title.8' :'상품 담당자',
  'pages_product_ProductInfo.title.9' :'최종 수정일',
  'pages_product_ProductInfo.title.10' :'첨부 파일(브로슈어)',
  'pages_product_ProductInfo.title.11' :'첨부 파일(상품 소개서)',
  'pages_product_ProductInfo.title.12' :'첨부 파일(기타)',
}

export default ProductInfo



// WEBPACK FOOTER //
// ./src/lang/product/ProductInfo.kr.js